var _path, _path2, _path3, _path4, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTaxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 9.99717C2.33398 8.60163 2.89676 7.74638 4.06139 7.09825L8.8555 4.43027C11.3676 3.03226 12.6236 2.33325 14.0007 2.33325C15.3777 2.33325 16.6337 3.03226 19.1458 4.43027L23.9399 7.09825C25.1045 7.74637 25.6673 8.60163 25.6673 9.99717C25.6673 10.3756 25.6673 10.5648 25.626 10.7204C25.4089 11.5376 24.6683 11.6666 23.9532 11.6666H4.04815C3.33297 11.6666 2.59242 11.5376 2.37531 10.7204C2.33398 10.5648 2.33398 10.3756 2.33398 9.99717Z",
    stroke: "#242429",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 11.6667V21.5834M9.33268 11.6667V21.5834",
    stroke: "#242429",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 21.5833H5.83398C3.90099 21.5833 2.33398 23.1503 2.33398 25.0833C2.33398 25.4054 2.59515 25.6666 2.91732 25.6666H12.834",
    stroke: "#242429",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 16.9166L16.9173 25.0833",
    stroke: "#242429",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.791,
    cy: 17.7917,
    r: 0.875,
    stroke: "#242429",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.209,
    cy: 24.2083,
    r: 0.875,
    stroke: "#242429",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxes);
export default __webpack_public_path__ + "static/media/icon-taxes.6eabff79e86b22127bf9151c1db65d91.svg";
export { ForwardRef as ReactComponent };